import type { MeResponse } from '@licita/contracts';
import {
  createRootRoute,
  createRoute,
  createRouter,
  lazyRouteComponent,
  stripSearchParams,
  type SearchSchemaInput,
} from '@tanstack/react-router';
import { createContext } from 'react';
import Shell from './components/Shell';
import { FILTROS_PADRAO, validarFiltros } from './lib/editais';

export const SessionContext = createContext<{ me: MeResponse | null; staging: boolean; signOut: () => void }>({
  me: null,
  staging: false,
  signOut: () => {},
});

const root = createRootRoute({ component: Shell });
const page = (path: string, load: () => Promise<{ default: React.ComponentType }>) =>
  createRoute({ getParentRoute: () => root, path, component: lazyRouteComponent(load) });

/** Lista de editais: filtros na query string (link compartilhável); só o que difere do padrão fica na URL. */
export const editaisRoute = createRoute({
  getParentRoute: () => root,
  path: '/editais',
  component: lazyRouteComponent(() => import('./pages/Editais')),
  // SearchSchemaInput: o link para /editais não precisa passar filtros (os padrões entram no validador).
  validateSearch: (raw: Record<string, unknown> & SearchSchemaInput) => validarFiltros(raw),
  search: { middlewares: [stripSearchParams(FILTROS_PADRAO)] },
});

export const editalRoute = createRoute({
  getParentRoute: () => root,
  path: '/editais/$id',
  component: lazyRouteComponent(() => import('./pages/Edital')),
});

const routeTree = root.addChildren([
  page('/', () => import('./pages/Inicio')),
  editaisRoute,
  editalRoute,
  page('/sincronizacao', () => import('./pages/Sincronizacao')),
]);

export const router = createRouter({ routeTree, defaultPreload: 'intent' });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
